import React from 'react';
import { Link } from 'react-router-dom';

const Success = () => {
  return (
    <div className="container text-center mt-5">
      <h1 className="display-4">Congratulations!</h1>
      <p className="lead">Your form has been submitted successfully.</p>
      <Link to="/" className="btn btn-primary">
        Back to Home
      </Link>
    </div>
  );
};

export default Success;
